import React, {useState, useEffect} from 'react'
//! Styles
import './appm-3.style.css'
//! Actions
import { NhealthAction } from '../../_actions/action.api'
//! JSON
import Hospital from '../../utils/JSON/hospital.json'
//! MUI
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { TextField } from '@mui/material';
//! Moment
import moment from 'moment';
import { Base_API } from '../../_actions/matcher';
import { useParams } from 'react-router-dom';
import { DecryptedOBJ } from '../../utils/Encryption';
//! Line Login
import useLineLogin from '../../_actions/authLine/lineLogin'
import lineConfig from '../../_actions/authLine/lineConfig';


function ReAppointment_2(props) {
    const {appointId, tranid} = useParams();
    const reappoinform_1 = DecryptedOBJ(window.localStorage.getItem('reappoint-1-form'));

    const [dataForm, setDataForm] = useState(
        [
            {
                id: 1,
                title: 'สาขาที่สะดวกเข้ารับบริการ',
                dd_list: [
                    'Select your answer',
                    'Lorem'
                ],
                value: '',
                input_name: 'branchesConvReceiveServices',
            },
            {
                id: 2,
                title: 'ทำนัดเพื่อเข้ารับบริการ (วันที่สะดวกเข้ารับบริการ)',
                input_type: 'text',
                input_name: 'dateofappmforservice',
                place_holder: 'ทำนัดเพื่อเข้ารับบริการ',
                value: ''
            },
            {
                id: 3,
                title: 'เวลาที่สะดวกเข้ารับบริการ',
                input_name: 'timeConvReceiveService',
                checkbox_list: ['08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00'],
                value: ''
            }
        ]
    )
    const [dateSelected, setDateSelected] = useState("")
    const [workDay, setWorkDay] = useState({
        "WorkofMon": "",
        "WorkofTue": "",
        "WorkofWed": "",
        "WorkofThu": "",
        "WorkofFri": "",
        "WorkofSat": "",
        "WorkofSun": "",
    });
    const [formSubmit, setFormSubmit] = useState(
        {
            hospital_id: '',
            hospital_name: '',
            appointment_date: '',
            time: ''
        }
    );
    const [timeList, setTimeList] = useState([]);
    const [errorMsg, setErrorMsg] = useState('กรุณาระบุข้อมูลให้ครบถ้วน.');
    const [errorStatus, setErrorStatus] = useState(false);
    const [checkboxSelected, setCheckboxSelected] = useState(null);
    // date of appointment
    const [doa, setDoa] = useState(null);

    // check & clear
    useEffect(() => {
        // check & fixed height container
        if(timeList.length > 0)
        {
            document.querySelector('.appm-3_container').style.height = '100%';
        }
        if(reappoinform_1 === null)
        {
            onBack();
        }
    })
    useEffect(() => {
        // clear
        if(window.localStorage.getItem('formData_page-3') !== null)
        {
            window.localStorage.removeItem('formData_page-3');
            window.location.reload();
        }
    },[])

    const onBack = () => {
        window.location.href = `/lab/n-health/reappointment-1/${tranid}/${appointId}`;
    }
    const onSubmit = (e) => {
        e.preventDefault();
        if(formSubmit["appointment_date"] !== "" && formSubmit["hospital_id"] !== "" && formSubmit["hospital_name"] !== "" && formSubmit["time"] !== "")
        {
            if(doa !== 'Invalid' && doa !== 'Invalid date')
            {
                let reqData = {
                    hisid: appointId,
                    Firstname: reappoinform_1[0].value,
                    Lastname: reappoinform_1[1].value,
                    Birthday: reappoinform_1[2].value,
                    Phoneno: reappoinform_1[3].value,
                    Email: reappoinform_1[4].value,
                    appointmentDate: `${formSubmit.appointment_date} ${formSubmit.time}`,
                    receive_service_code: formSubmit.hospital_id,
                    receive_service: formSubmit.hospital_name,
                    type: 0
                }
                // console.log(reqData);
                NhealthAction.UpdateHistory(reqData)
                .then(res => {
                    // console.log(res)
                    if(res.isSuccess === true)
                    {
                        window.location.href = `${Base_API.pathWeb}/n-health/reappointment-3`;
                    }
                })
            }else
            {
                setErrorMsg('กรุณาระบุวันนัดหมายให้ถูกต้อง.');
                setErrorStatus(true);
            }
        }else
        {
            setErrorMsg('กรุณากรอกข้อมูลให้ครบถ้วน.');
            setErrorStatus(true);
        }
    }
    const handleCheckbox = (e, index) => {
        let checked = e.target.checked;
        let value = e.target.name;
        
        if(checked)
        {
            setCheckboxSelected(index);
            // document.querySelector(`.appm-3-checkbox_label-${index}`).style.backgroundColor = '#1459A3'
            // document.querySelector(`.appm-3-checkbox_label-${index}`).style.color = 'white'

            formSubmit["time"] = `${String(value).length > 1 ? `${String(value)}:00` : `0${String(value)}:00`} - ${String(Number(value)+1).length > 1 ? `${String(Number(value)+1)}:00` : `0${String(Number(value)+1)}:00`}`;
        }else
        {
            setCheckboxSelected(null);
            // document.querySelector(`.appm-3-checkbox_label-${index}`).style.backgroundColor = 'transparent'
            // document.querySelector(`.appm-3-checkbox_label-${index}`).style.color = '#929AA3'
            formSubmit["time"] = "";
        }
    }
    const onChangeInput = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let hospital_name = String(value).split("/")[0];
        let hospital_id = String(value).split("/")[1];
        
        // hospital name
        if(name === 'dropdown-select')
        {
            if(value !== 'default') 
            {
                document.querySelector(`.${e.target.name}`).style.color = "#202020";
                //console.log(value)
    
                formSubmit["hospital_name"] = hospital_name;
                formSubmit["hospital_id"] = hospital_id;

                new Promise(resolve => {
                    let workDayList = {};

                    Hospital.hospital.map(item => {
                        if(item.hospitalId === hospital_id)
                        {
                            workDayList = {
                                "WorkofMon": item.WorkofMon,
                                "WorkofTue": item.WorkofTue,
                                "WorkofWed": item.WorkofWed,
                                "WorkofThu": item.WorkofThu,
                                "WorkofFri": item.WorkofFri,
                                "WorkofSat": item.WorkofSat,
                                "WorkofSun": item.WorkofSun,
                            };
    
                            setWorkDay(workDayList);
                            //console.log(workDayList)
                            resolve(workDayList)
                        }
                    })
                })

            }else
            {
                document.querySelector(`.${e.target.name}`).style.color = "#D2D9E3";
                setWorkDay({
                    "WorkofMon": "",
                    "WorkofTue": "",
                    "WorkofWed": "",
                    "WorkofThu": "",
                    "WorkofFri": "",
                    "WorkofSat": "",
                    "WorkofSun": "",
                });
            }
        }

        // date
        if(name === 'dateofappmforservice')
        {
            new Promise(resolve => {
                formSubmit["appointment_date"] = value;
                setDateSelected(String(new Date(value)).split(" ")[0]);
                resolve(String(new Date(value)).split(" ")[0])
            })
            .then(data => {
                let timeList = [];

                if(data === "Mon")
                {
                    let timeForm = Number(String(String(workDay.WorkofMon).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofMon).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Tue")
                {
                    let timeForm = Number(String(String(workDay.WorkofTue).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofTue).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Wed")
                {
                    let timeForm = Number(String(String(workDay.WorkofWed).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofWed).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Thu")
                {
                    let timeForm = Number(String(String(workDay.WorkofThu).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofThu).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Fri")
                {
                    let timeForm = Number(String(String(workDay.WorkofFri).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofFri).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Sat")
                {
                    let timeForm = Number(String(String(workDay.WorkofSat).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofSat).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
            })
        }
    } 
    const onChangeDoa = (e) => {
        setDoa(e)
        const doa1 = moment(e, "DD/MM/YYYY").format("DD/MM/YYYY");

        if(doa1 !== 'Invalid date' && doa1 !== '')
        {
            new Promise(resolve => {
                formSubmit["appointment_date"] = doa1;
                setDateSelected(String(e).split(" ")[0]);
                resolve(String(e).split(" ")[0])
            })
            .then(data => {
                let timeList = [];
    
                if(data === "Mon")
                {
                    let timeForm = Number(String(String(workDay.WorkofMon).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofMon).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Tue")
                {
                    let timeForm = Number(String(String(workDay.WorkofTue).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofTue).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Wed")
                {
                    let timeForm = Number(String(String(workDay.WorkofWed).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofWed).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Thu")
                {
                    let timeForm = Number(String(String(workDay.WorkofThu).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofThu).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Fri")
                {
                    let timeForm = Number(String(String(workDay.WorkofFri).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofFri).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
                if(data === "Sat")
                {
                    let timeForm = Number(String(String(workDay.WorkofSat).split("-")[0]).split(":")[0]);
                    let timeTo = Number(String(String(workDay.WorkofSat).split("-")[1]).split(":")[0]); 
                    let tList = [];
                    for(let i=timeForm; i<=timeTo; i++)
                    {
                        tList.push(i); 
                    }
                    setTimeList(tList)
                }
            })
        }

    }

    return (
        <div className="appm-3_container">
            <div className="appm-3-form_wrapper">
                {/* header */}
                <h1 className="appm-3-form_header">ทำนัดหมาย</h1>

                {/* dropdown items */}
                <form onSubmit={onSubmit} className="appm-3-input_wrapper">
                        <div className="appm-3-input_item">
                            <span className='normal-black'>{dataForm[0].title}</span>
                            <select
                                className={`dropdown-select`}
                                name={`dropdown-select`}
                                onChange={e => onChangeInput(e)}
                            >
                                <option value="default">
                                    Select your answer 
                                </option>
                                {Hospital.hospital.map((item, i) => 
                                    <option value={`${item.hospitalName}/${item.hospitalId}`} key={item.hospitalId}>
                                        {item.hospitalName}
                                    </option>
                                )}
                            </select>
                        </div>
                        {/* date */}
                        <div className="appm-2-input_item">
                            <span className='normal-black'>ทำนัดเพื่อเข้ารับบริการ (วันที่สะดวกเข้ารับบริการ)</span>
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <MobileDatePicker
                                    label="ระบุวันนัดหมาย"
                                    inputFormat="dd/MM/yyyy"
                                    minDate={new Date(`${new Date().getFullYear()}/${String(new Date().getMonth()+1)}/${new Date().getDate()+1}`)}
                                    maxDate={new Date('2022/09/30')}
                                    value={doa}
                                    onChange={(e) => onChangeDoa(e)}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider> 
                        </div>
                        {/* time of conv recieve service */}
                        <div className="appm-3-input_item">
                            <span className='normal-black'>{dataForm[2].title}</span>
                            <ul className="appm-3-checkbox_item-wrapper">
                                {timeList.map((item, i) => 
                                    <div key={i}>
                                        <input 
                                            type="checkbox"
                                            name={item}
                                            id={item}
                                            className={`appm-3-checkbox_item`}
                                            onChange={(e) => handleCheckbox(e, i)}
                                        >
                                        </input>
                                        <label 
                                            className={checkboxSelected === i ? `appm-3-checkbox_label active` : `appm-3-checkbox_label`}
                                            htmlFor={item}
                                        >
                                                {String(item).length > 1 ? `${item}:00` : `0${item}:00`}
                                        </label>
                                    </div>
                                )}
                            </ul>
                        </div>
                    {/* alert error */}
                    <p style={errorStatus ? {display: 'block'} : {display: 'none'}} className="appm-3-alert_error">
                        {errorMsg}
                    </p>

                    {/* button */}
                    <div className="appm-3-button_wrapper">
                        <button 
                            className="appm-3-btn_back"
                            type='button'
                            onClick={onBack}
                        >
                            ย้อนกลับ
                        </button>
                        <button 
                            className="appm-3-btn_submit"
                            type="submit"
                        >
                            ถัดไป
                        </button>
                    </div>
                </form>
            </div>
            {/* footer */}
            <p className="footer-text">Copyright © 2022 National Healthcare Systems Company Limited All rights reserved</p> 
        </div>
    )
}

export default ReAppointment_2